import { Enrollment } from "@api/types/enrollments";
import { FC, useEffect, useState } from "react";

const EnrolledCourseImage: FC<{ enrollment: Enrollment }> = ({ enrollment }) => {
  const [src, setSrc] = useState<string>(null);

  useEffect(() => {
    setSrc(enrollment?.thumbnail?.url);
  }, [enrollment]);

  return (
    <>
      <div className="EnrolledCourseImage">
        <img src={src} />
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .EnrolledCourseImage {
          }

          .EnrolledCourseImage img {
            width: 100%;
            max-width: 100%;
          }
        `}
      </style>
    </>
  );
};

export default EnrolledCourseImage;
